import { getTrackingDisallowedCookie } from '#pplx/frontend/apps/ask/browser-state/cookieManager.js';
import { useIsUserLoggedIn } from '#pplx/frontend/auth/userHooks.js';
import { isCometMobileBrowser } from '#pplx/frontend/comet/client/utils.js';
import { getCookieHasClickedGetApp } from '#pplx/frontend/cookies/metadataCookieManager.js';
import { useGetCookie } from '#pplx/frontend/cookies/useGetCookie.js';
import { useIsMobile } from '#pplx/frontend/platform-components/useMobileStyle.js';
import { useWebPlatform } from '#pplx/frontend/platform-components/useWebPlatform.js';
import { usePathname } from '#pplx/frontend/router/usePathname.js';
import { useSearchParams } from '#pplx/frontend/router/useSearchParams.js';
export const PPLX_MWEB_SPLASH_PAGE_DISMISSED_ANDROID = 'pplx.mweb-splash-page-dismissed';
/**
 * Determines whether the mobile splash screen should be shown.
 * Android: Old "Download now" splash (logged-out only, tracking allowed).
 * Excluded: other platforms and Comet browser.
 */
export function useShouldShowSplashScreen() {
    const { device: { isAndroid }, } = useWebPlatform();
    const { isMobileUserAgent } = useIsMobile();
    const pathname = usePathname();
    const searchParams = useSearchParams();
    const isMobileComet = isCometMobileBrowser();
    const { value: isAndroidSplashDismissed } = useGetCookie(PPLX_MWEB_SPLASH_PAGE_DISMISSED_ANDROID);
    const isUserLoggedIn = useIsUserLoggedIn();
    const hasTrackingDisallowed = getTrackingDisallowedCookie();
    const onHomepageWithoutQueryParams = pathname === '/' && (searchParams === null || searchParams.size === 0);
    if (!isAndroid) {
        return false;
    }
    if (!isMobileUserAgent) {
        return false;
    }
    if (isMobileComet) {
        return false;
    }
    if (!onHomepageWithoutQueryParams) {
        return false;
    }
    if (isUserLoggedIn) {
        return false;
    }
    if (hasTrackingDisallowed) {
        return false;
    }
    if (getCookieHasClickedGetApp()) {
        return false;
    }
    return isAndroidSplashDismissed !== 'true';
}
//# sourceMappingURL=useShouldShowSplashScreen.js.map